import Image from 'next/image'
import Link from 'next/link'

import NavTextNodes from '@data/i18n/nav.json'

import { formatDateString } from '@lib/utils/dates'

import RichTextSerializer from '@components/RichTextSerializer'

type Props = {
	featuredArticle: any
}

function FeaturedArticleHeader({ featuredArticle }: Props) {
	const {
		title,
		topics,
		date,
		uid,
		description,
		hero_image: heroImage
	} = featuredArticle?.article?.data || {}

	return featuredArticle ? (
		<header className="mb-8 gallery-box section">
			<div className="container relative z-10 flex items-end justify-end">
				{/* Box */}
				<div className="bg-white p-8 md:p-12 lg:p-16 md:pr-0 max-w-[550px]">
					<div className="mb-4 text-sm font-medium text-gray-500">
						{topics?.[0]?.topic?.data?.title?.[0]?.text && (
							<>
								<span className="">{topics?.[0]?.topic?.data?.title?.[0]?.text}</span> &middot;{' '}
							</>
						)}
						<time>{formatDateString(date)}</time>
					</div>

					{/* Title */}
					<h2 className="text-4xl title">{title?.[0]?.text}</h2>

					{/* Description */}
					<div className="subtitle max-md:line-clamp-3">
						<RichTextSerializer content={description} />
					</div>

					{/* CTA */}
					{/* TODO: Make CTAButton component */}
					<Link legacyBehavior href={`${NavTextNodes.theMagUrl}/article/${uid}`}>
						<a className="mt-6 button button-primary">Read more</a>
					</Link>
				</div>
			</div>
			{heroImage?.url && (
				<div className="absolute inset-0 md:right-[15vw] max-w-[1400px]">
					<Image
						layout="fill"
						objectFit="cover"
						src={heroImage.url}
						alt={heroImage.alt || title?.[0]?.text || 'Magazine article image'}
						sizes="85vw"
					/>
				</div>
			)}
		</header>
	) : null
}

export default FeaturedArticleHeader
